/**
 * PLEX-6744: would leaving the page lose a Classic chat turn?
 *
 * A turn is in flight while its stream is open or its dispatch hasn't been answered.
 * Reloading or closing the tab doesn't stop it: LLMClient.dispose keeps the backend turn
 * running. When the backend saves the conversation (backend_owns_history: the dispatch
 * answered history_persisted, client.historyPersisted), nothing is lost either; on return
 * the chat shows the turn still running and loads it when it ends (PLEX-6303). Otherwise
 * the page itself still has to save what the turn produces, and leaving loses it.
 */

export const chatTurnInFlight = (client) =>
  client?.streamId != null || !!client?.waitingForResponse;

export const unloadLosesChatTurn = (client) =>
  chatTurnInFlight(client) && !client?.historyPersisted;
